/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Copy_Command_LabelInputs */

const en_mcp_copy_command_label = /** @type {(inputs: Mcp_Copy_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy command`)
};

const es_mcp_copy_command_label = /** @type {(inputs: Mcp_Copy_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar comando`)
};

/**
* | output |
* | --- |
* | "Copy command" |
*
* @param {Mcp_Copy_Command_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_copy_command_label = /** @type {((inputs?: Mcp_Copy_Command_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Copy_Command_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_copy_command_label(inputs)
	return en_mcp_copy_command_label(inputs)
});